<template>
  <div class="dg-add-column-btn">
    <b-dropdown variant="success" size="sm" :noCaret="true">
      <template slot="button-content">
        <icon name="plus" />
        <span>Add Column</span>
      </template>
      <!-- Dropdown items -->
      <b-dropdown-item
        href="#"
        v-for="(control, idx) in controls"
        :key="idx"
        @click.prevent="addColumn(control.type)"
      >
        <icon :name="control.icon" />
        <span>{{ control.text }}</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      controls: [
        { type: 'string', text: 'Text', icon: 'font' },
        { type: 'multiline_text', text: 'Multiline Text', icon: 'font' },
        { type: 'number', text: 'Number', icon: 'list-ol' },
        { type: 'date', text: 'Date', icon: 'calendar' },
        {
          type: 'lookup',
          method: 'addLookUpColumn',
          text: 'Look Up',
          icon: 'table',
        },
        {
          type: 'multi_lookup',
          method: 'addLookUpColumn',
          text: 'Multi Look Up',
          icon: 'table',
        },
        { type: 'files', text: 'Files', icon: 'files-o' },
        { type: 'custom', text: 'Custom Code', icon: 'code' },
        { type: 'checkbox', text: 'Checkbox', icon: 'check-square-o' },
        { type: 'user', text: 'User', icon: 'user-circle' },
        { type: 'profile_image', text: 'Profile Image', icon: 'image' },
        { type: 'datagrid', text: 'DataGrid', icon: 'table' },
        { type: 'select', text: 'Select', icon: 'list' },
        { type: 'workflow', text: 'Workflow', icon: 'globe' },
        { type: 'qrScan', text: 'QR Scan', icon: 'qrcode' },
        { type: 'text_editor', text: 'Rich Editor', icon: 'font' }
      ],
    }
  },
  computed: {
    ...mapState(['currentDash']),
  },
  methods: {
    addColumn(type) {
      this.$emit('showAddColumnModal', type)
    },
  },
}
</script>

<style lang="scss">
.dg-add-column-btn {
  .dropdown-toggle::after {
    display: none;
  }
}
</style>
